import React from 'react';
import { connect } from 'react-redux';
import { DBDropDownObjective, ObjectiveFlag } from '_components';
import styles from './Common.module.css'

class StrengthPelvicFloorPower extends React.Component {

    render() {
        let dropdownOptions = [
            { id: 0, value: 0 },
            { id: 1, value: 1 },
            { id: 2, value: 2 },
            { id: 3, value: 3 },
            { id: 4, value: 4 },
            { id: 5, value: 5 }
        ];
        let dropdownExternalOptions = [
            { id: 'absent', value: 'absent' },
            { id: 'weak', value: 'weak' },
            { id: 'moderate', value: 'moderate' },
            { id: 'strong', value: 'strong' }
        ];

        return (
            <div>
            <div className={styles.textfield_row}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.flagged} mopno={this.props.mopno} flagText='Strength - Pelvic Floor Power'/>
                        <label className={styles.textarea_label}>Pelvic Floor Power</label>
                        <div className={styles.pelv}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='STNO'
                                entityKeyValue={this.props.stno}
                                field='STPELVICFLOORPOWER'
                                className={styles.pelv_ddl}
                                customOptions={dropdownOptions}
                            />
                          </div>
                        <span className={styles.prev_comments_wrapper}>
                            {this.props.prevVal}
                        </span>
                    </div>

                    <div className={styles.textfield_row}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.internalFlagged} mopno={this.props.mopno} flagText='Strength - Pelvic Floor Power'/>
                        <label className={styles.sublabel}>Internal</label>
                        <DBDropDownObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVESTR'
                            entityKeyColumn='STNO'
                            entityKeyValue={this.props.stno}
                            field='STPELVICFLOORPOWERINTR'
                            className={styles.r}
                            customOptions={dropdownOptions}
                        />
                        <span className={styles.c} >
                            <span className={styles.prev_wrapper}>
                                {this.props.prevInternalR}
                            </span>
                        </span>
                        <DBDropDownObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVESTR'
                            entityKeyColumn='STNO'
                            entityKeyValue={this.props.stno}
                            field='STPELVICFLOORPOWERINTL'
                            className={styles.l}
                            customOptions={dropdownOptions}
                        />
                        <span className={styles.prev_wrapper}>
                            {this.props.prevInternalL}
                        </span>
                    </div>
                     <div className={styles.textfield_row}>
                      <ObjectiveFlag className={styles.flag} flagged={this.props.externalFlagged} mopno={this.props.mopno} flagText='Strength - Pelvic Floor Power'/>
                        <label className={styles.sublabel}>External</label>
                        <DBDropDownObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVESTR'
                            entityKeyColumn='STNO'
                            entityKeyValue={this.props.stno}
                            field='STPELVICFLOORPOWEREXTR'
                            className={styles.r}
                            customOptions={dropdownExternalOptions}
                        />
                        <span className={styles.c} >
                            <span className={styles.prev_wrapper}>
                                {this.props.prevExternalR}
                            </span>
                        </span>
                        <DBDropDownObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVESTR'
                            entityKeyColumn='STNO'
                            entityKeyValue={this.props.stno}
                            field='STPELVICFLOORPOWEREXTL'
                            className={styles.l}
                            customOptions={dropdownExternalOptions}
                        />
                        <span className={styles.prev_wrapper}>
                            {this.props.prevExternalL}
                        </span>
                    </div>
                </div>
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let stno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVESTR)
        .find(key => (state.entities.notes.PTOBJECTIVESTR[key].STEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVESTR[key].STNTNO === pk && noteType !== 1)));

    let prevVal = '';
    let prevInternalR = '';
    let prevInternalL = '';
    let prevExternalR = '';
    let prevExternalL = '';
    if (noteType !== 1 && state.entities.notes.PTOBJECTIVESTRPREV[pk]) {
        prevVal = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STPELVICFLOORPOWER'];
        prevInternalR = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STPELVICFLOORPOWERINTR'];
        prevInternalL = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STPELVICFLOORPOWERINTL'];
        prevExternalR = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STPELVICFLOORPOWEREXTR'];
        prevExternalL = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STPELVICFLOORPOWEREXTL'];
    }

    return {
        noteId,
        stno,
        flagged: state.entities.notes.PTOBJECTIVESTR[stno]?.STPELVICFLOORPOWER !== null,
        internalFlagged: state.entities.notes.PTOBJECTIVESTR[stno]?.STPELVICFLOORPOWERINTR !== null && state.entities.notes.PTOBJECTIVESTR[stno]?.STPELVICFLOORPOWERINTL !== null,
        externalFlagged: state.entities.notes.PTOBJECTIVESTR[stno]?.STPELVICFLOORPOWEREXTR !== null && state.entities.notes.PTOBJECTIVESTR[stno]?.STPELVICFLOORPOWEREXTL !== null,
        prevVal,
        prevInternalR,
        prevInternalL,
        prevExternalR,
        prevExternalL,
    };
}

const connectedStrengthPelvicFloorPower = connect(mapStateToProps)(StrengthPelvicFloorPower);
export { connectedStrengthPelvicFloorPower as StrengthPelvicFloorPower };


